import React from 'react';
import clientServices from '../../services/client';
import { withRouter, Link } from 'react-router-dom';
import LoadingScreen from '../LoadingScreen';
import PageHeader from '../boxes/PageHeader';
import Modal from '../boxes/Modal';
import PageBody from '../boxes/PageBody';
import MainContent from '../boxes/MainContent';
import DataTable from '../boxes/DataTable';
import EnrolleeFilter from '../boxes/EnrolleeFilter';
import Box from '@mui/material/Box';
import Usersvg from '../../User.svg';
import UserPlus from '../../UserPlus.svg';
import {
    getDaysToCoverEnd,
    getPaymentFrequency,
    getCoverWarningType
} from '../InvoiceDetailsComponent';
import NotificationBanner from '../boxes/NotificationBanner';
import { useTranslation, withTranslation } from 'react-i18next';
import { appConfig } from '../../config/appConfig';
import i18next from 'i18next';
import { getActiveStatus } from '../../utils/enrolleeStatus';

class EmployeeListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            viewEnrollee: false,
            invoiceList: [],
            showInvoiceList: false,
            selectedStatus: '',
            searchInput: '',
            search: null,
            isLoading: false,
            tableData: [],
            totalEnrolleeCount: 0,
            activeEnrolleeCount: 0,
            exportError: null
        };
    }

    handleExportError = (message) => {
        this.setState({ exportError: message });
    };

    closeExportError = () => {
        this.setState({ exportError: null });
    };

    componentDidMount() {
        const { user } = this.props;
        clientServices
            .getInvoices(user.credentials.accessToken, user.companyInfo.id)
            .then((response) => {
                this.setState({
                    invoiceList: response
                });
            });
        this.getTableData();
        this.getEnrolleeCounts();
    }

    fetchAllEnrollees = () => {
        const { user, location } = this.props;
        const { accessToken } = user.credentials;
        const clientId = user.companyInfo.id;
        const invoiceRefCode = location.state ? location.state.invoiceRefCode : '';
        const PAGE_SIZE = 500;

        const filters = {
            ...(this.state.selectedStatus && {
                active_status_id: this.state.selectedStatus
            }),
            ...(this.state.search && { s: this.state.search }),
            ...(invoiceRefCode && { invoice_ref_code: invoiceRefCode })
        };

        const fetchPage = (page) =>
            clientServices.getStaff(accessToken, clientId, {
                ...filters,
                limit: PAGE_SIZE,
                page
            });

        return fetchPage(1).then((firstResponse) => {
            const firstPageData = firstResponse?.data || [];
            const total = firstResponse?.pagination?.total || firstPageData.length;
            const totalPages = Math.ceil(total / PAGE_SIZE);

            if (totalPages <= 1) return firstPageData;

            const remainingRequests = [];
            for (let page = 2; page <= totalPages; page++) {
                remainingRequests.push(fetchPage(page));
            }

            return Promise.all(remainingRequests).then((responses) => {
                const remainingData = responses.reduce(
                    (acc, response) => acc.concat(response?.data || []),
                    []
                );
                return firstPageData.concat(remainingData);
            });
        });
    };

    getEnrolleeCounts = () => {
        const { user } = this.props;
        const { accessToken } = user.credentials;
        const clientId = user.companyInfo.id;
        const baseQuery = { limit: 1, page: 1 };

        Promise.all([
            clientServices.getStaff(accessToken, clientId, baseQuery),
            clientServices.getStaff(accessToken, clientId, { ...baseQuery, active_status_id: 1 })
        ])
            .then(([totalResponse, activeResponse]) => {
                this.setState({
                    totalEnrolleeCount: totalResponse?.pagination?.total || 0,
                    activeEnrolleeCount: activeResponse?.pagination?.total || 0
                });
            })
            .catch((error) => {
                 console.error("Failed to fetch staff:", error);
            });
    };

    renderLoading() {
        return (
            <MainContent>
                <PageHeader title="" />
                <PageBody>
                    <LoadingScreen />
                </PageBody>
            </MainContent>
        );
    }

    searchEnrollees = (searchTerm) => {
        this.setState({
            search: searchTerm
        });
    };

    toggleShowInvoiceList = () => {
        this.setState({
            showInvoiceList: !this.state.showInvoiceList
        });
    };

    selectStatus = (e) => {
        this.setState({ selectedStatus: e.target.value });
    };

    setLoading = (isLoading) => {
        this.setState({
            isLoading
        });
    };

    getTableData = (page = 1, filter = '', limit = 100) => {
        const { user, location } = this.props;
        const invoiceRefCode = location.state ? location.state.invoiceRefCode : '';

        const dataSource = {
            clientId: user.companyInfo.id,
            accessToken: user.credentials.accessToken,
            invoice_ref_code: invoiceRefCode,
            active_status_id: this.state.selectedStatus,
            s: this.state.search
        };
        const { accessToken, clientId } = dataSource;
        const queryData = { limit, page, q: filter };

        if (dataSource) {
            this.setLoading(true);

            clientServices
                .getStaff(accessToken, clientId, queryData)
                .then((response) =>
                    this.setState({
                        isLoading: false,
                        tableData: response
                    })
                )
                .catch((error) => {
                    this.setLoading(false);
                });
        } else {
            this.setState({
                tableData: []
            });
        }
    };

    getEmployeeColumnData() {
        const { t } = this.props;
        const employeeColumnData = [
            {
                key: 'id',
                type: 'string',
                alias: t('employees.dataTableSerialNumberColumnAlias')
            },
            {
                key: 'hmo_id',
                type: 'string',
                alias: t('employees.dataTableHmoIdColumnAlias')
            },
            {
                key: 'first_name',
                type: 'string',
                alias: t('employees.dataTableEmployeeNameColumnAlias'),
                format: (data) =>
                    getActiveStatus(data.active_status_id) === 'active' ? (
                        <Link
                            to={`/dashboard/staff/${data.id}`}
                        >{`${data.first_name}  ${data.last_name}`}</Link>
                    ) : (
                        <p>{`${data.first_name}  ${data.last_name}`}</p>
                    )
            },
            {
                key: 'email_address',
                type: 'string',
                alias: t('employees.dataTableEmailColumnAlias')
            },
            {
                key: 'product_name',
                type: 'string',
                alias: t('employees.dataTablePlanColumnAlias')
            },
            {
                key: 'active_status_id',
                type: 'string',
                alias: t('employees.dataTableStatusColumnAlias'),
                format: (data) =>
                    getActiveStatus(data.active_status_id) === 'active' ? (
                        <Box
                            sx={{
                                width: 'fit-content',
                                background: '#E7F6EC',
                                borderRadius: '12px',
                                padding: '5px 10px',
                                fontWeight: '500',
                                color: '#036B26'
                            }}
                        >
                            {t('employees.activeStatus')}
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                width: 'fit-content',
                                background: '#FFEFEE',
                                borderRadius: '12px',
                                padding: '5px 10px',
                                fontWeight: '500',
                                color: '#C8322B'
                            }}
                        >
                            {t('employees.inactiveStatus')}
                        </Box>
                    )
            },
            {
                key: 'has_profile',
                type: 'string',
                alias: t('employees.dataTableProfileColumnAlias'),
                format: (data) =>
                    data.has_profile ? (
                        <Box
                            sx={{
                                width: 'fit-content',
                                background: '#E7F6EC',
                                borderRadius: '12px',
                                padding: '5px 10px',
                                fontWeight: '500',
                                color: '#036B26'
                            }}
                        >
                            {t('employees.completeProfile')}
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                width: 'fit-content',
                                background: '#FFEFEE',
                                borderRadius: '12px',
                                padding: '5px 10px',
                                fontWeight: '500',
                                color: '#C8322B'
                            }}
                        >
                            {t('employees.incompleteProfile')}
                        </Box>
                    )
            }
        ];

        return employeeColumnData;
    }

    render() {
        const { user, location, invoice, t } = this.props;
        const invoiceRefCode = location.state ? location.state.invoiceRefCode : '';
        const daysToCoverEnd = getDaysToCoverEnd(invoice?.end_date);

        return (
            <MainContent>
                <PageHeader title={t('employees.employeesPageTitle')} />
                {this.state.exportError && (
                    <NotificationBanner
                        title={t('common.errorNotificationTitle', 'Error')}
                        message={this.state.exportError}
                        type="error"
                        close={this.closeExportError}
                    />
                )}
                {/* {daysToCoverEnd <= 45 &&
                    (getPaymentFrequency(invoice?.payment_frequency_id) === 'Quarterly' ||
                        getPaymentFrequency(invoice.payment_frequency_id) === 'Biannually') && (
                        <NotificationBanner
                            title={t('employees.planExpiryNotificationModalTitle')}
                            message={
                                daysToCoverEnd <= 0
                                    ? t('employees.insurancePlanExpiredMessage', {
                                          expiryDate: invoice?.end_date,
                                          comanyName: appConfig.companyName
                                      })
                                    : t('employees.insurancePlanToExpireMessage', {
                                          expiryDate: invoice?.end_date,
                                          dayToExpiration: daysToCoverEnd,
                                          comanyName: appConfig.companyName
                                      })
                            }
                            type={getCoverWarningType(daysToCoverEnd)}
                            action={t('employees.planExpiryActionButtonText')}
                            path="/dashboard/plan-reactivation"
                        />
                    )} */}
                <div className="employees-stats-row">
                    <div className="employee-stat-item">
                        <div className="employee-stat-image-container">
                            <img src={UserPlus} />
                        </div>
                        <div className="employee-stats-text">
                            <p>{t('employees.enrolleeCount')}</p>
                            <p>
                                {t('common.quantity', {
                                    quantity: this.state.totalEnrolleeCount
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="employee-stat-item">
                        <div className="employee-stat-image-container">
                            <img src={Usersvg} />
                        </div>
                        <div className="employee-stats-text">
                            <p>{t('employees.activeEnrollees')}</p>
                            <p>
                                {t('common.quantity', {
                                    quantity: this.state.activeEnrolleeCount
                                })}
                            </p>
                        </div>
                    </div>
                    {/* <div className="employee-stat-item">
                        <div className="employee-stat-image-container"><img /></div>
                        <div className="employee-stats-text">
                            <p>Slots Available</p>
                            <p>0</p>
                        </div>
                    </div> */}
                </div>

                <PageBody>
                    <div className="employees-list-wrapper">
                        {this.state.showInvoiceList && (
                            <InvoiceListModal
                                invoices={this.state.invoiceList}
                                canModify={user.companyInfo.canModify}
                                onClose={this.toggleShowInvoiceList}
                            />
                        )}
                        <EnrolleeFilter
                            status={this.state.selectedStatus}
                            selectStatus={this.selectStatus}
                            searchEnrollees={this.searchEnrollees}
                            addEmployees={this.toggleShowInvoiceList}
                            data={this.state.tableData.data}
                            fetchAllEnrollees={this.fetchAllEnrollees}
                            onExportError={this.handleExportError}
                        />
                        <DataTable
                            dataSource={{
                                clientId: user.companyInfo.id,
                                accessToken: user.credentials.accessToken,
                                invoice_ref_code: invoiceRefCode,
                                active_status_id: this.state.selectedStatus,
                                s: this.state.search
                            }}
                            tableColumnData={this.getEmployeeColumnData()}
                            options={[
                                {
                                    value: 'View Employee',
                                    label: t('employees.viewEmployeeTableOptionLabel')
                                },
                                {
                                    value: 'Renew Plan',
                                    label: t('employees.renewPlanTableOptionLabel')
                                },
                                {
                                    value: 'Remove Employee',
                                    label: t('employees.removeEmployeeTableOptionLabel')
                                }
                            ]}
                        />
                    </div>
                </PageBody>
            </MainContent>
        );
    }
}

const InvoiceListModal = ({ invoices, canModify, onClose }) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={t('employees.invoiceListModalTitle')}
            subtitle={t('employees.invoiceListModalSubtitle')}
            onClose={onClose}
        >
            <InvoiceList invoices={invoices} canModify={canModify} />
        </Modal>
    );
};

const InvoiceList = ({ invoices, canModify }) => {
    const { t } = useTranslation();
    const validInvoices = invoices.filter((invoice) => invoice.has_enrollees_left);

    return validInvoices.length > 0 ? (
        <div className="invoice-list-card-wrapper">
            {validInvoices.map((invoice) => (
                <div className="invoice-list-card" key={invoice.reference_code}>
                    <div className="invoice-ref" style={{textAlign: i18next.dir() === 'ltr' ? 'left' : 'right'}}>#{invoice.reference_code}</div>
                    <div className="invoice-description" style={{textAlign: i18next.dir() === 'ltr' ? 'left' : 'right'}}>{invoice.description}</div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <div>
                            <div className="invoice-price">
                                {t('common.amount', { amount: invoice.total_price })}
                            </div>
                            {invoice.issue_time && (
                                <div className="invoice-date">
                                    {t('common.date', {
                                        date: invoice.issue_time,
                                        formatParams: {
                                            date: {
                                                weekday: 'long',
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            }
                                        }
                                    })}
                                </div>
                            )}
                        </div>
                        <button
                            onClick={() => {}}
                            className="employee-list-btn"
                            style={{
                                cursor: 'pointer',
                                background: 'white',
                                border: '1px solid rgb(222, 222, 222)'
                            }}
                        >
                            <Link
                                style={{ textDecoration: 'none', color: 'black' }}
                                to={`/dashboard/invoices/edit/add-staff?refCode=${invoice.reference_code}`}
                            >
                                {t('employees.invoiceSelectButtonText')}
                            </Link>
                        </button>
                    </div>
                </div>
            ))}
        </div>
    ) : canModify ? (
        <div style={{ maxWidth: '500px', textAlign: 'center' }}>
            <p style={{ fontSize: '1.6rem', lineHeight: '2.4rem' }}>
                {t('employees.newPlanPurchaseInstruction')}
            </p>
            <Link to="/dashboard/invoices/edit/new-invoice">
                <button className="primary_button">
                    {t('employees.newPlanPurchaseButtonText')}
                </button>
            </Link>
        </div>
    ) : (
        <p
            style={{ fontSize: '1.6rem', maxWidth: '500px', lineHeight: '2.4rem' }}
            dangerouslySetInnerHTML={{
                __html: t('employees.availableSlotUsedUpMessage', {
                    email: appConfig.supportEmailAddress
                })
            }}
        />
    );
};

const EmployeeListComponentWithTranslation = withTranslation()(EmployeeListComponent);
export default withRouter(EmployeeListComponentWithTranslation);
